import React, { useContext } from 'react';
import BtnOffcanvas from '../../../Components/btn/btnOffcanvas';
import OffcanvasBase from '../../../Components/offcanvas/offcanvasBase';
import NavbarLinks from './navbarLinks';
import { AppConfigContext } from '../../../Config/App';

const Navbar = () => {
    const { assets_url } = useContext(AppConfigContext)
    return (
        <header>
            <nav className="navbar navbar-dark navbar-expand-lg py-3 purple-navbar global-shadow">
                <div className="container p-sm-0">

                    <div className='col d-flex justify-content-between'>
                        <a href="https://pokeland-legends.club">
                            <img alt="Pokeland Legends Club" className='d-lg-none navbar-logo' src={assets_url('pokeland_legends_club_logo.webp')}></img>
                        </a>
                        <BtnOffcanvas classes="navbar-toggler" disabled={false} offcanvas="navbar-mobile">
                            <span className="navbar-toggler-icon"></span>
                        </BtnOffcanvas>
                    </div>

                    <div className="col-12 d-none d-lg-flex justify-content-between align-items-center">
                        <a href="https://pokeland-legends.club">
                            <img alt="Pokeland Legends Club" className='navbar-logo' src={assets_url('pokeland_legends_club_logo.webp')}></img>
                        </a>
                        <NavbarLinks />
                    </div>

                    <div className='col-12 d-block d-lg-none'>
                        <OffcanvasBase id="navbar-mobile">
                            <NavbarLinks />
                        </OffcanvasBase>
                    </div>
                </div>
            </nav>
        </header>
    );
}
export default Navbar;